<div class="vehicle-tacho">

    <ng-container *ngIf="!isLoadingData">
        <app-vehicle-tacho-slots
            *ngIf="slots?.length"
            (onChangeSlot$)="setActiveSlot($event)"
            [activeSlotIndex]="activeSlotIdx"
            [slots]="slots"
            [tachoData]="_item.Tacho"
        ></app-vehicle-tacho-slots>
        
        <ng-container *ngIf="activeSlot">
            <app-driver-tacho [slotData]="activeSlot"></app-driver-tacho>
            <app-tacho-summary-data [slotData]="activeSlot"></app-tacho-summary-data>

            <div class="list-data">
                <div class="list-data__item">
                    <span class="list-data__item__title">
                        {{'vehicle-details-tacho-tab.daily-cycle-start'|translate}}
                    </span>
                    <span class="list-data__item__value">{{activeSlot.StartDay | date:'HH:mm'}}, {{activeSlot.StartDay | date:'d MMM'}}</span>
                </div>
                <div class="list-data__item">
                    <span class="list-data__item__title">
                        {{'vehicle-details-tacho-tab.recommendation-9h-rest'|translate}}
                    </span>
                    <span class="list-data__item__value">{{activeSlot.Recommended_Rest9h | date:'HH:mm'}}, {{activeSlot.Recommended_Rest9h | date:'d MMM'}}</span>
                </div>
                <div class="list-data__item">
                    <span class="list-data__item__title">
                        {{'vehicle-details-tacho-tab.recommendation-11h-rest'|translate}}
                    </span>
                    <span class="list-data__item__value">{{activeSlot.Recommended_Rest11h | date:'HH:mm'}}, {{activeSlot.Recommended_Rest11h | date:'d MMM'}}</span>
                </div>
            </div>
    
            <div class="details-wrapper">
                <app-tacho-data-details
                    *ngIf="sectionDataActiveSlot?.Drive"
                    [dataType]="TACHO_TYPE_DATA.Driving"
                    [data]="sectionDataActiveSlot.Drive"
                    [slotData]="activeSlot"
                ></app-tacho-data-details>
                <app-tacho-data-details
                    *ngIf="sectionDataActiveSlot?.Work"
                    [dataType]="TACHO_TYPE_DATA.Work"
                    [data]="sectionDataActiveSlot.Work"
                    [slotData]="activeSlot"
                ></app-tacho-data-details>
                <app-tacho-data-details
                    *ngIf="sectionDataActiveSlot?.Rest"
                    [dataType]="TACHO_TYPE_DATA.Rest"
                    [data]="sectionDataActiveSlot.Rest"
                    [slotData]="activeSlot"
                ></app-tacho-data-details>
                <div class="white-space"></div>
            </div>
        </ng-container>
    </ng-container>

    <app-tacho-empty-state *ngIf="!isLoadingData && (!slots || slots.length === 0)"></app-tacho-empty-state>

    <div *ngIf="isLoadingData" class="loading-state">
        <p-skeleton *ngFor="let item of [1,1,1]" height="5rem"></p-skeleton>
        <p-skeleton class="third" height="14rem"></p-skeleton>
        <p-skeleton *ngFor="let item of [1,1]" height="14rem"></p-skeleton>
    </div>
</div>
